// extracted by mini-css-extract-plugin
export default {"wrapper":"Popover_wrapper__REMW3","trigger":"Popover_trigger__YNeXo","summary":"Popover_summary__9lVaD","panel":"Popover_panel__YHKHF"};